
<script>
export default {
  name: "GenericFilter",
  props: {
    query: {
      type: Object,
      default: () => {},
    },
    filterName: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handleFilter() {
      const query = { ...this.$route.query };
      query[this.filterName] = this.query[this.filterName];

      this.$router.replace({ query, q: Date.now() }).catch(() => {});
    },
    clearFilter() {
      const query = { ...this.$route.query };
      this.$delete(query, this.filterName);
      this.$router.push({ query }).catch(() => {});
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler({ query }) {
        if (query[this.filterName]) {
          if (/^\d+$/.test(query[this.filterName])) {
            this.query[this.filterName] = Number(query[this.filterName]);
          } else {
            query[this.filterName] = query[this.filterName];
          }
        } else {
          this.$delete(this.query, this.filterName);
        }
      },
    },
  },
};
</script>
